import bluetoothRepository from "@/bluetooth/BluetoothRepository";
import router from "@/router";
import StoreType from "./StoreType";
import { DeviceId, WriterSetting } from "../BluetoothData";

const BRAND_PRODUCT_MAP = {
  0: {
    //AVD
    3: "GDC",
    4: "stem2",
    5: "2 ML"
  },
  1: {
    // IK
    3: "UZO",
    4: "NORD",
    5: "TIK",
    6: "Lipstick",
    7: "510 Pen",
    8: "TIK PRO",
    9: "D019",
    10: "CREST"
  },
  2: {
    //unicore
    3: "ALLY",
    4: "2ML",
    5: "YT009",
    6: "LG",
    7: "DM061",
    8: "DM026",
    9: "DM004C",
    10: "CY122",
    11: "CY308",
    12: "CY308C",
    13: "CY653",
    14: "CY688",
    0x10: "VF001",
    0x11: "YT022", //有档位 2挡 有间隔 没温控
    0x12: "YT029", //有档位 2挡 没间隔 没温控
    0x13: "YT026", //有档位 2挡 有间隔 没温控
    0x14: "YT025", //拨动开关 有间隔 没温控
    0x15: "YT024", //有档位 2挡 有间隔 没温控
    0x16: "AD280", //无档位 1挡 有间隔 没温控
    0x17: "AD290", //无档位 1挡 有间隔 没温控
    0x18: "YCC24-031", //无档位 1挡 有间隔 没温控
    0x19: "YT023", //按键有档位 2挡 有间隔 没温控
    0x20: "AD287", //无档位 有间隔 没温控 功率
    0x21: "YT028", //有档位 2档 有间隔 没温控
    0x22: "AD230", //无档位，无按键，有间隔 没温控
    0x23: "AD282", //无档位，无按键，有间隔 没温控
    0x24: "T10", ///无档位 3挡，有间隔 不管
    0x25: "R01", ///有档位 6挡，有间隔 不管
    0x26: "YCC24-002", //无档位 1挡 有间隔 没温控
    0x27: "AD287-002", //无档位 有间隔 没温控 功率
    0x28: "CA15", //有档位 ,有间隔 先不管
    0x29: "AD287-002", //无档位 有间隔 没温控 功率
    0x30: "CY308D", //无档位 有间隔  没温控
    0x31: "YT033", // 有档位 2档 有间隔 没温控
    0x32: "AD287", //无档位 有间隔 没温控 功率  没温控
    0x33: "YT045", //有档位 有间隔 双仓 左右中 没温控
    0x34: "YT035", //有档位 有间隔 没温控 v4 双仓
    0x35: "YT026-002", //有档位 2挡 有间隔 没温控
    0x36: "YT027", //有档位 2挡 有间隔
    0x37: "YT035", //有档位 有间隔 没温控 v4 双仓
    0x38: "YT065", //有档位 有间隔 没温控 v4
    0x39: "YT055", //有档位 有间隔 v4 只有电压和温控 三仓 咪头灵敏度为推送功率
    0x3A: "YT029-A", //有档位 2挡 有间隔 没温控
    0x3B: "YT035-B", //有档位 有间隔 没温控 v4 双仓
    0x3C: "YT035-C", //有档位 有间隔 没温控 v4 双仓
    0x3D: "YT031", //有档位 有间隔 2档
    0x3E: "YT075", //有档位 有间隔 2档
    0x3F: "YT025X", //拨动开关 有间隔 没温控
    0x40: "YT055B", ///有档位 有间隔  只有电压和温控 三仓 咪头灵敏度为推送功率
    0x41: "YT035C-2", ///有档位-拨动开关 有间隔 没温控  双仓
    0x42: "YT055C", ///有档位 有间隔 v4 只有电压和温控 三仓 咪头灵敏度为推送功率
    0x43: "YT036", //有档位 有间隔 2档
    0x44: "YT027X", //有档位 2挡 有间隔
    0x45: "YT028-2", //有档位 3挡 有间隔
    0x46: "YT035C-2", ///有档位-无拨动开关 有间隔 没温控  双仓
    0x47: "YT035-B", ///有档位-无拨动开关 有间隔 没温控  双仓
    0x48: "AD235", ///有档位-无拨动开关 有间隔 没温控  双仓
    0x49: "F004-2", ///有档位-无拨动开关 有间隔 没温控  双仓
    0x50: "F002", ///无档位-无拨动开关 有间隔 没温控
    0x51: "YT037", ///有档位-无拨动开关 有间隔 没温控  双仓
    0x52: "YT035C-3", ///有档位-无拨动开关 有间隔 没温控  双仓
    0x53: "F003", ///无档位-无拨动开关 有间隔 没温控
    0x54: "YT038", ///有档位，3档-无拨动开关 有间隔 没温控
    0x55: "YT035D", ///拨动开有间隔   双仓
    0x56: "YT075C", ///有档位 有间隔 没温控 左右中 没温控
    0x57: "YT039", ///有档位 有间隔 没温控 左右中 没温控
    0x58: "YT024A", ////无档位-无拨动开关 有间隔 没温控
    0x59: "YT075E", ////无档位-无拨动开关 有间隔 没温控
    0x60: "YT026-3", //无档位-无拨动开关 有间隔 没温控
    0x61: "YT023-2", //无档位-无拨动开关 有间隔 没温控
    0x62: "YT031-2", //无档位-无拨动开关 有间隔 没温控
    0x63: "F013", //无档位-无拨动开关 有间隔 没温控
    0x64: "F012", //无档位-无拨动开关 有间隔 没温控
    0x65: "F005", //无档位-无拨动开关 有间隔 没温控
    0x66: "F006", //无档位-无拨动开关 有间隔 没温控
    0x67: "YT055S", //有档位 有间隔  只有电压和温控 三仓
    0x68: "F009", //有间隔  只有电压
    0x69: "F004-3", //有档位 有间隔  只有电压和温控 三仓
    0x70: "F015", //有档位 有间隔  只有电压和温控 三仓
    0x71: "YT030", //无档位-无拨动开关 有间隔 没温控
    0x72: "YT055B8", //无档位-无拨动开关 有间隔 没温控
    0x73: "YT055C8", //无档位-无拨动开关 有间隔 没温控
    0x74: "YT095-1", //无档位-无拨动开关 有间隔 没温控
    0x75: "YT095-2", //有间隔 双仓
    0x76: "YT035P", //有间隔 双仓
    0x77: "YT035Bomb", //有间隔 双仓
    0x78: "KV002", //有间隔   双仓
    0x79: "YT085", // //单曲线
    0x7A: "F004-1", //8个点 双仓
    0x7B: "YT065A", //F002 ///无档位-无拨动开关 有间隔 没温控
    0x7C: "YT035X", //YT035P ///有间隔 双仓
    0x7D: "F004-1", //8个点 三仓
    0x7E: "F021", //单曲线
    0x7F: "F022", //3档 间隔
    0x80: "KV003", //单曲线
    0x81: "BF006", //3档 间隔
    0x82: "F004-2", ///有档位-无拨动开关 有间隔 没温控  双仓 6个点
    0x83: "F004-1", // 6个点 双仓
    0x84: "F004-3", // 6个点 三仓
    0x85: "YT062", // 6个点 双仓
    0x86: "YT068", // 6个点 双仓
    0x87: "AC029", // 6个点 3档
    0x88: "F026", // 6个点 双仓
    0x89: "F023", // 6个点 双仓
    0x8a: "YT055S-ZB", // 8个点 双仓
    0x8b: "F011", // 6个点 单仓 单档
    0x8c: "F024", // 6个点 单仓 单档
    0x8d: "F028", // 6个点 双仓
    0x8e: "F027", // 6个点 双仓
    0x8f: "YT035P", //有间隔 双仓
    0x90: "F029", //无档位，无仓位
    0x91: "YT055WIFI", //无档位，无仓位
  },
  3: {
    //高品
    //DM
    1: "HS064",
    2: "HS023",
    3: "HS1012",
    4: "HS023",
    5: "HS051",
    6: "HS012",
    7: "HS011",
    8: "HS068", // 拨动开关
    9: "HS090",
    0x0a: "HS630"
  },
  4: {
    //XS 先生
    1: "FJ-V2"
  },
  5: {
    1: "Fu",
    2: "Baller"
  }
};
export const BluetoothStore = {
  namespaced: true,
  state: () => ({
    isConnected: false, //是否已经连接到蓝牙
    isInsert: false, //是否插入烟弹
    battery: 100, //电池电量
    currentPuff: 0, //总口数
    maxPuff: 10000, //最大口数，目前不需要从设备读取，写死10000秒
    preheat: {
      //读取到的设备的预热
      time: 10, //预热秒数
      temperature: 400 //预热温度
    },
    diy: {
      //diy温度
      time: 0,
      secondTemperature: []
    },
    todaySeconds: 0, // 今日抽烟秒数
    todayPuff: 0, // 今日抽烟口数
    usageSeconds: 0, // 当前烟弹已经使用秒数
    deviceVersion: "", //设备版本信息
    macAddress: "", //设备mac 地址
    isNeedSync: false, //是否需要同步数据
    syncSmokeData: {},
    deviceName: "", //设备名称
    fireMode: -1, //点火模式
    isFire: false, //是否正在点火
    isDiyFire: false, //是否正在diy点火
    isPreheat: false, //预热是否启动
    isDiy: false, //diy是否启动
    batchId: "", //烟弹的批次id
    podId: "", //烟弹id
    oilType: 0, //烟油类型
    brandType: 0, //品牌类型
    capacity: 0, //溶剂容量
    flavor: 0, //口味
    manufacture: 0, //厂商
    country: 0, //国家地区
    city: 0, //城市地区
    thickness: 0, //浓稠度
    cartridgeFlag: 0, //烟弹标识符
    oilContent: 0, //烟油含量
    atomizingWire: 0, //雾化丝类型
    volte: 0, //电压
    r: 0, //电阻
    constantTemperature: 0, //恒温
    heatingFactor: 0, //加热系数
    isLock: false, //设备是否锁定
    isBind: false, //设备是否绑定
    encryptType: 0, //加密类型
    userIdFlag: 0, //用户标识
    currentTime: 0, //当前时间
    preheatName: "", //预热名称
    diyName: "", //diy名称
    activedTime: "",
    bleVersion: "",
    hasError: false,
    //
    tempTemperatureMode: null, //预设界面的临时存储用,
    deviceInfoFromServer: null, //服务器中存储的设备名称
    presets: [],
    isPresetChanged: false,
    presetName: "PRESETS",
    hubSetting: null,
    writerSetting: null,
    writerSetting2: null,
    deviceId: new DeviceId(),
    isDeviceSupportRead: false,
    insertDeviceName: "Device",
    deviceList: [],
    //
    outputMode: 0,
    curveTitle: "Temperature Settings",
    unitName: "v",
    dragValue: {
      max: -4200,
      min: -100,
      step: 100
    },
    r1: 0,
    materialType: 1,

    doubleR1: 0,
    doubleMaterialType: 1,

    tripleR1: 0,
    tripleMaterialType: 1,

    hubOutputMode: 0,
    hubCurveTitle: "Temperature Settings",
    hubUnitName: "v",
    hubDragValue: {
      max: -4200,
      min: -100,
      step: 100
    }
  }),
  mutations: {
    [StoreType.COMMIT_TYPE.STATE_TEMPERATURE_R1](state, payload) {
      state.r1 = payload;
    },
    [StoreType.COMMIT_TYPE.STATE_TEMPERATURE_DOUBLE_R1](state, payload) {
      state.doubleR1 = payload;
    },
    [StoreType.COMMIT_TYPE.STATE_TEMPERATURE_DOUBLE_R2](state, payload) {
      state.tripleR1 = payload;
    },
    [StoreType.COMMIT_TYPE.STATE_CONNECT_STATE](state, payload) {
      if (payload === StoreType.ConnectState.CONNECT_STATE_CONNECTING) {
        return;
      }
      state.isConnected =
          payload === StoreType.ConnectState.CONNECT_STATE_CONNECTED;
    },
    [StoreType.COMMIT_TYPE.STATE_CARTRIDGE_IS_INSERT](state, payload) {
      if (!payload) {
        state.currentPuff = 0;
        state.usageSeconds = 0;
        state.totalSeconds = 0;
        state.todaySeconds = 0;
        state.maxPuff = 0;
      }
      state.isInsert = payload;
    },
    [StoreType.COMMIT_TYPE.STATE_BATTERY](state, payload) {
      state.battery = payload;
    },
    [StoreType.COMMIT_TYPE.STATE_CURRENT_PUFF](state, payload) {
      state.currentPuff = payload;
    },
    [StoreType.COMMIT_TYPE.STATE_MAX_PUFF](state, payload) {
      state.maxPuff = payload;
    },
    [StoreType.COMMIT_TYPE.STATE_PREHEAT](state, payload) {
      state.preheat = payload;
    },
    [StoreType.COMMIT_TYPE.STATE_DIY](state, payload) {
      state.diy = payload;
    },
    [StoreType.COMMIT_TYPE.STATE_TODAY_SECONDS](state, payload) {
      state.todaySeconds = payload;
    },
    [StoreType.COMMIT_TYPE.STATE_TODAY_PUFF](state, payload) {
      state.todayPuff = payload;
    },
    [StoreType.COMMIT_TYPE.STATE_TOTAL_SECONDS](state, payload) {
      state.totalSeconds = payload;
    },
    [StoreType.COMMIT_TYPE.STATE_USAGE_SECONDS](state, payload) {
      state.usageSeconds = payload;
    },
    [StoreType.COMMIT_TYPE.STATE_DEVICE_VERSION](state, payload) {
      state.deviceVersion = payload;
    },
    [StoreType.COMMIT_TYPE.STATE_SMOKE_DATA](state, payload) {
      state.syncSmokeData = payload;
    },
    [StoreType.COMMIT_TYPE.STATE_MAC_ADDRESS](state, payload) {
      state.macAddress = payload;
    },
    [StoreType.COMMIT_TYPE.STATE_IS_NEED_SYNC](state, payload) {
      state.isNeedSync = payload;
    },
    [StoreType.COMMIT_TYPE.STATE_DEVICE_NAME](state, payload) {
      state.deviceName = payload;
    },
    [StoreType.COMMIT_TYPE.STATE_FIRE_MODE](state, payload) {
      state.fireMode = payload;
    },
    [StoreType.COMMIT_TYPE.STATE_IS_FIRE](state, payload) {
      state.isFire = payload;
    },
    [StoreType.COMMIT_TYPE.STATE_IS_DIY_FIRE](state, payload) {
      state.isDiyFire = payload;
    },
    [StoreType.COMMIT_TYPE.STATE_IS_PREHEAT](state, payload) {
      state.isPreheat = payload;
    },
    [StoreType.COMMIT_TYPE.STATE_IS_DIY](state, payload) {
      state.isDiy = payload;
    },
    [StoreType.COMMIT_TYPE.STATE_BATCH_ID](state, payload) {
      state.batchId = payload;
    },
    [StoreType.COMMIT_TYPE.STATE_POD_ID](state, payload) {
      state.podId = payload;
    },
    [StoreType.COMMIT_TYPE.STATE_OIL_TYPE](state, payload) {
      state.oilType = payload;
    },
    [StoreType.COMMIT_TYPE.STATE_BRAND_TYPE](state, payload) {
      state.brandType = payload;
    },
    [StoreType.COMMIT_TYPE.STATE_CAPACITY](state, payload) {
      state.capacity = payload;
    },
    [StoreType.COMMIT_TYPE.STATE_FLAVOR](state, payload) {
      state.flavor = payload;
    },
    [StoreType.COMMIT_TYPE.STATE_MANUFACTURE](state, payload) {
      state.manufacture = payload;
    },
    [StoreType.COMMIT_TYPE.STATE_COUNTRY](state, payload) {
      state.country = payload;
    },
    [StoreType.COMMIT_TYPE.STATE_CITY](state, payload) {
      state.city = payload;
    },
    [StoreType.COMMIT_TYPE.STATE_THICKNESS](state, payload) {
      state.thickness = payload;
    },
    [StoreType.COMMIT_TYPE.STATE_CARTRIDGE_FLAG](state, payload) {
      state.cartridgeFlag = payload;
    },
    [StoreType.COMMIT_TYPE.STATE_OIL_CONTENT](state, payload) {
      state.oilContent = payload;
    },
    [StoreType.COMMIT_TYPE.STATE_ATOMIZING_WIRE](state, payload) {
      state.atomizingWire = payload;
    },
    [StoreType.COMMIT_TYPE.STATE_COMMAND_RESISTANCE](state, payload) {
      state.r = payload;
    },
    [StoreType.COMMIT_TYPE.STATE_CONSTANT_TEMPERATURE](state, payload) {
      state.constantTemperature = payload;
    },
    [StoreType.COMMIT_TYPE.STATE_HEATING_FACTOR](state, payload) {
      state.heatingFactor = payload;
    },
    [StoreType.COMMIT_TYPE.STATE_IS_LOCK](state, payload) {
      state.isLock = payload;
    },
    [StoreType.COMMIT_TYPE.STATE_IS_BIND](state, payload) {
      state.isBind = payload;
    },
    [StoreType.COMMIT_TYPE.STATE_ENCRYPT_TYPE](state, payload) {
      state.encryptType = payload;
    },
    [StoreType.COMMIT_TYPE.STATE_USER_ID_FLAG](state, payload) {
      state.userIdFlag = payload;
    },
    [StoreType.COMMIT_TYPE.STATE_DEVICE_TIME](state, payload) {
      state.currentTime = payload;
    },
    [StoreType.COMMIT_TYPE.STATE_DIY_NAME](state, payload) {
      state.diyName = payload;
    },
    [StoreType.COMMIT_TYPE.STATE_PREHEAT_NAME](state, payload) {
      state.preheatName = payload;
    },
    [StoreType.COMMIT_TYPE.STATE_TEMP_TEMPERATURE_MODE](state, payload) {
      state.tempTemperatureMode = payload;
    },
    [StoreType.COMMIT_TYPE.STATE_DEVICE_INFO_FROM_SERVER](state, payload) {
      state.deviceInfoFromServer = payload;
    },
    [StoreType.COMMIT_TYPE.STATE_ACTIVE_TIME](state, payload) {
      state.activedTime = payload;
    },
    [StoreType.COMMIT_TYPE.STATE_BLUETOOTH_VERSION](state, payload) {
      state.bluetoothVersion = payload;
    },
    [StoreType.COMMIT_TYPE.STATE_PRESET_FROM_SERVER](state, payload) {
      state.presets = payload;
    },
    [StoreType.COMMIT_TYPE.STATE_CURRENT_WRITER_SETTING](state, payload) {
      state.writerSetting = payload;
    },
    [StoreType.COMMIT_TYPE.STATE_CURRENT_WRITER_SETTING2](state, payload) {
      state.writerSetting2 = payload;
    },
    [StoreType.COMMIT_TYPE.STATE_CURRENT_HUB_SETTING](state, payload) {
      state.hubSetting = payload;
    },
    [StoreType.COMMIT_TYPE.STATE_PRESET_IS_CHANGED](state, payload) {
      state.isPresetChanged = payload;
    },
    [StoreType.COMMIT_TYPE.STATE_DEVICE_ID](state, payload) {
      state.deviceId = payload;
      // const productManufacture = payload.productManufacture
      // if (productManufacture === 0x01) {
      //   switch (payload.productNumber) {
      //     case 3: //uzo
      //       state.insertDeviceName = "UZO";
      //       break;
      //     case 4: //nord
      //       state.insertDeviceName = "NORD";
      //       break;
      //     default:
      //       state.insertDeviceName = "Device";
      //       break;
      //   }
      // } else if (productManufacture == 0x00) {
      //     switch (payload.productNumber) {
      //
      //     }
      // } else {
      //   state.insertDeviceName = "Device";
      // }
      if (payload == null) {
        state.insertDeviceName = "Unknown";
        return;
      }
      const productManufactureCode = payload.productManufacture & 0x0f;
      const productManufacture = BRAND_PRODUCT_MAP[`${productManufactureCode}`];
      if (!productManufacture) {
        state.insertDeviceName = "Unknown";
        return;
      }
      const productName = productManufacture[`${payload.productNumber}`];
      if (!productManufacture) {
        state.insertDeviceName = "Unknown";
        return;
      }
      state.insertDeviceName = productName;
    },
    [StoreType.COMMIT_TYPE.STATE_IS_DEVICE_SUPPORT_READ](state, payload) {
      state.isDeviceSupportRead = payload;
    },
    [StoreType.COMMIT_TYPE.STATE_PRESET_NAME](state, payload) {
      state.presetName = payload;
      if (payload === "PRESETS") {
        state.presets.forEach(item => {
          if (item.active) {
            item.active = false;
          }
        });
        state.presets = Object.assign([], state.presets);
      }
    },

    [StoreType.COMMIT_TYPE.STATE_SCAN_DEVICE_LIST](state, payload) {
      state.deviceList = payload;
    },

    setMaterialType(state, payload) {
      state.materialType = payload;
    },

    setMaterialType2(state, payload) {
      state.materialType2 = payload;
    },
    setHubOutputMode(state, mode) {
      state.hubOutputMode = mode;
      switch (mode) {
        case 0:
        case 0x10:
          state.hubCurveTitle = "Voltage Curve";
          state.hubUnitName = "v";
          state.hubDragValue = {
            max: -4200,
            min: -100,
            step: 100
          };
          break;
        case 0x20:
          state.hubCurveTitle = "Power Curve";
          state.hubUnitName = "w";
          state.hubDragValue = {
            max: -1500,
            min: -10,
            step: 10
          };
          break;
        case 0x40:
          state.hubCurveTitle = "Temperature Settings";
          state.hubUnitName = "";
          break;
        default:
          state.hubCurveTitle = "Voltage Curve";
          state.hubUnitName = "v";
          state.hubDragValue = {
            max: -4200,
            min: -100,
            step: 100
          };
          break;
      }
    },
    setOutputMode(state, mode) {
      state.outputMode = mode;
      switch (mode) {
        case 0:
        case 0x10:
          state.curveTitle = "Voltage Curve";
          state.unitName = "v";
          state.dragValue = {
            max: -4200,
            min: -100
          };
          break;
        case 0x20:
          state.curveTitle = "Power Curve";
          state.unitName = "w";
          state.dragValue = {
            max: -1500,
            min: -10
          };
          break;
        case 0x40:
          state.curveTitle = "Temperature Settings";
          state.unitName = "";
          break;
        default:
          state.curveTitle = "Voltage Curve";
          state.unitName = "v";
          state.dragValue = {
            max: -4200,
            min: -100
          };
          break;
      }
    },
    setDeviceName(state, payload) {
      let deviceInfoFromServer = Object.assign({}, deviceInfoFromServer);
      deviceInfoFromServer.deviceName = payload;
      state.deviceInfoFromServer = deviceInfoFromServer;
    },
    setInsertDeviceName(state, payload) {
      state.insertDeviceName = payload;
    }
  },
  actions: {
    async changeTemperatureMode({ state, commit, rootState }) {
      if (!state.isPresetChanged) {
        //没有改变
        return;
      }
      let presets = state.presets.filter(item => item.active);
      if (!presets) {
        return;
      }

      let temperature = presets[0].heatingModeList[0].temperature.split(",");
      let sixTemperaturePoint = [];

      let secondTemperature = [];
      temperature.forEach((y, x) => {
        secondTemperature.push({ x: x + 1, y });
        if (x < 6) {
          sixTemperaturePoint.push(y);
        }
      });

      const temperatureMode = {
        name: presets[0].heatingModeList[0].operatingModeName,
        secondTemperature
      };
      await bluetoothRepository.writeTemperatureMode(temperatureMode);
      // await cartridge.saveCustomDiyTemperature(
      //   presets[0].id,
      //   sixTemperaturePoint.join(","),
      //   state.podId
      // );
    },

    async keyDownChangeDiyTemperature({ state, commit, rootState }, params) {
      const { temperature } = params;

      let name = state.diyName;
      let secondTemperature = state.diy.secondTemperature;
      secondTemperature.forEach(item => {
        item.y = temperature;
      });
      const temperatureMode = {
        name,
        secondTemperature
      };
      await bluetoothRepository.writeTemperatureMode(temperatureMode);
      commit(StoreType.COMMIT_TYPE.STATE_PRESET_NAME, "PRESETS");
    },

    async afterConnectHandle(context) {
      const { batchId, podId, macAddress, deviceVersion } = context.state;
      // await device.deviceConnection(batchId, macAddress, podId, deviceVersion);

      // let deviceInfoFromServer = await device.getDeviceInfo(
      //       //   context.state.macAddress
      //       // );
      //       // context.commit(
      //       //   StoreType.COMMIT_TYPE.STATE_DEVICE_INFO_FROM_SERVER,
      //       //   deviceInfoFromServer
      //       // );

      //提交状态到vuex
      context.commit(
          StoreType.COMMIT_TYPE.STATE_CONNECT_STATE,
          StoreType.ConnectState.CONNECT_STATE_CONNECTED
      );
      router.replace({ name: "device" });
    },

    async syncSmokeData(context, payload) {},
    async fetchDataAfterInsert(context) {
      await bluetoothRepository.fetchDeviceData();
    },

    async loadPresets(context) {
      // let presetTypes = await cartridge.presetTypes(context.state.podId);
      // if (presetTypes.length !== 0) {
      //   presetTypes[0]["active"] = true;
      // }
      //
      // context.commit(
      //   StoreType.COMMIT_TYPE.STATE_PRESET_FROM_SERVER,
      //   presetTypes
      // );
    },
    async _setDeviceName({ commit }, payload) {
      commit("setDeviceName", payload);
    }
  },
  getters: {
    getInsertDeviceName(state, getters, rootState) {
      return state.insertDeviceName;
    },
    connectState(state, getters, rootState) {
      return state.isConnected ? "CONNECTED" : "DISCONNECTED";
    },
    battery(state, getters, rootState) {
      if (!state.isConnected) {
        return 0;
      }
      return state.battery;
    },

    coilLife(state, getters, rootState) {
      if (!state.isConnected) {
        return 0;
      }
      if (!state.isInsert) {
        return 0;
      }

      return ((1 - state.currentPuff / 10000) * 100).toFixed(0);
    },

    dailyHitsAvg(state, getters, rootState) {
      if (!state.isConnected) {
        return "";
      }

      if (!state.isInsert) {
        return 0;
      }
      return (state.todaySeconds / state.currentPuff / 5).toFixed(0);
    },

    totalHitAvg(state, getters, rootState) {
      if (!state.isConnected) {
        return "";
      }
      if (!state.isInsert) {
        return 0;
      }
      return (state.usageSeconds / state.currentPuff).toFixed(2);
    },

    currentDiyFirstTemperature(state, getters, rootState) {
      if (
          state.diy.secondTemperature &&
          state.diy.secondTemperature.length > 0
      ) {
        return state.diy.secondTemperature[0].y;
      }
      return 300;
    },
    fireMode(state, getters, rootState) {
      return state.fireMode;
    },
    preheatInfo(state, getters, rootState) {
      return state.preheat;
    },
    diyInfo(state, getters, rootState) {
      return state.diy;
    },
    currentPuff(state, getters, rootState) {
      return state.currentPuff;
    },
    todaySeconds(state, getters, rootState) {
      return state.todaySeconds;
    },
    todayPuff(state, getters, rootState) {
      return state.todayPuff;
    },
    //
    isPreheat(state, getters, rootState) {
      return state.isPreheat;
    },
    getDeviceName(state, getters, rootState) {
      return state.isConnected
          ? (state.deviceInfoFromServer &&
              state.deviceInfoFromServer.deviceName) ||
          ""
          : "";
    },
    isConnected(state, getters, rootState) {
      return state.isConnected;
    },

    presetTypes(state, getters, rootState) {
      return state.presets;
    },
    isInsert(state, getters, rootState) {
      return state.isInsert;
    },
    podId(state, getters, rootState) {
      return state.podId;
    },
    selectedPresetItem(state, getters, rootState) {
      if (getters.presetsIsEmpty) {
        return null;
      }

      let filter = getters.presetTypes.filter(item => item.active);
      return filter[0];
    },

    presetsIsEmpty(state, getters, rootState) {
      return state.presets.length === 0;
    },
    //是否在输出
    isFire(state, getters, rootState) {
      return state.isFire || state.isDiyFire;
    },
    //是否在输出
    hasError(state, getters, rootState) {
      return state.hasError;
    },

    presetName(state, getters, rootState) {
      return state.presetName;
    },
    isPaste(state, getters, rootState) {
      return state.oilType === 4;
    },

    isVoltage(state, getters, rootState) {
      return state.oilType === 5;
    },
    macAddress(state, getters, rootState) {
      return state.macAddress;
    },
    cartridgeFlag(state, getters, rootState) {
      return state.cartridgeFlag;
    },
    writerSetting(state, getters, rootState) {
      return state.writerSetting;
    },
    deviceVersion(state, getters, rootState) {
      return state.deviceVersion;
    },
    deviceId(state, getters, rootState) {
      return state.deviceId;
    },
    getHubSetting(state, getters, rootState) {
      return state.hubSetting;
    }
  }
};
